import { SmallBusinessApplication } from '@/application/smallBusiness/domain/SmallBusinessApplication';
import { SmallBusinessRepository } from '@/application/smallBusiness/domain/SmallBusinessRepository';
import { UseCase } from '@/shared/application/UseCase';
import { UUID } from '@hfc/common';
import { SfApiResponse } from '@hfc/ui-core';

export class GetApplicationUseCase implements UseCase<UUID, SfApiResponse<SmallBusinessApplication>> {

  private repository: SmallBusinessRepository;

  public constructor (repository: SmallBusinessRepository) {
    this.repository = repository;
  }

  public async run (uuid: UUID): Promise<SfApiResponse<SmallBusinessApplication>> {
    return await this.repository.getApplication(uuid);
  }

}
